import React, { useState, useEffect } from "react";
import * as couponCodeAction from "../../../../redux/couponCode/couponCodeAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const CouponCode = () => {
  const { couponCodeDetails } = useSelector((state) => state.couponCodeInfo);
  const [couponForm, setCouponForm] = useState({
    couponCode: "",
    expireDate: "",
    discountType: "",
    value: "",
    isActive: true,
  });

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      dispatch(couponCodeAction.getCouponCodeDetails(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (couponCodeDetails && id) {
      const expiresAt = couponCodeDetails.expiresAt || couponCodeDetails.expireDate;
      const expireDate = expiresAt
        ? new Date(expiresAt).toISOString().split("T")[0]
        : "";
      
      setCouponForm({
        couponCode: couponCodeDetails.code || couponCodeDetails.couponCode || "",
        expireDate: expireDate,
        discountType: couponCodeDetails.discountType || "",
        value: couponCodeDetails.discountValue || couponCodeDetails.value || "",
        isActive: couponCodeDetails.isActive !== undefined ? couponCodeDetails.isActive : true,
      });
    }
  }, [couponCodeDetails, id]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setCouponForm({
      ...couponForm,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Transform form data to match backend API format
    const apiData = {
      code: couponForm.couponCode,
      discountType: couponForm.discountType,
      discountValue: parseFloat(couponForm.value),
      expiresAt: couponForm.expireDate,
      isActive: couponForm.isActive,
    };
    
    if (id) {
      dispatch(couponCodeAction.updateCouponCode(id, apiData, navigate));
    } else {
      dispatch(couponCodeAction.createCouponCode(apiData, navigate));
    }
  };

  const handleCancel = () => {
    navigate("/coupon-code/list");
  };

  return (
    <>
      <div>
        <div className="page-header">
          <h3 className="page-title">
            {id ? "Update Coupon Code" : "Create New Coupon Code"}
          </h3>
        </div>
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">
                  {id ? "Update Coupon Code details" : "Enter new Coupon Code details"}
                </h4>

                <form className="form-sample" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 mb-4">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="couponCode">
                              Coupon Code <span className="text-danger">*</span>
                            </label>
                            <input
                              onChange={handleInputChange}
                              value={couponForm.couponCode}
                              name="couponCode"
                              placeholder="Enter coupon code"
                              type="text"
                              id="couponCode"
                              className="form-control"
                              required
                              disabled={!!id}
                            />
                            {id && (
                              <small className="form-text text-muted">
                                Coupon code cannot be changed after creation
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="expireDate">
                              Expire Date <span className="text-danger">*</span>
                            </label>
                            <input
                              onChange={handleInputChange}
                              value={couponForm.expireDate}
                              name="expireDate"
                              type="date"
                              id="expireDate"
                              className="form-control"
                              required
                              min={new Date().toISOString().split("T")[0]}
                            />
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="discountType">
                              Discount Type <span className="text-danger">*</span>
                            </label>
                            <select
                              name="discountType"
                              className="custom-select"
                              value={couponForm.discountType}
                              required
                              onChange={handleInputChange}
                            >
                              <option value="" disabled>
                                Select discount type
                              </option>
                              <option value="percentage">Percentage (%)</option>
                              <option value="fixed">Fixed Amount</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-group">
                            <label htmlFor="value">
                              Discount Value <span className="text-danger">*</span>
                            </label>
                            <input
                              onChange={handleInputChange}
                              value={couponForm.value}
                              name="value"
                              placeholder={
                                couponForm.discountType === "percentage"
                                  ? "Enter percentage (e.g., 10 for 10%)"
                                  : "Enter fixed amount"
                              }
                              type="number"
                              min="0"
                              step={couponForm.discountType === "percentage" ? "1" : "0.01"}
                              max={couponForm.discountType === "percentage" ? "100" : undefined}
                              id="value"
                              className="form-control"
                              required
                            />
                            {couponForm.discountType === "percentage" && (
                              <small className="form-text text-muted">
                                Maximum 100%
                              </small>
                            )}
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-group">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="isActive"
                                name="isActive"
                                checked={couponForm.isActive}
                                onChange={handleInputChange}
                              />
                              <label className="form-check-label" htmlFor="isActive">
                                Active
                              </label>
                            </div>
                            <small className="form-text text-muted">
                              Inactive coupon codes cannot be used
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <button type="submit" className="btn btn-primary mr-2">
                        {id ? "Update" : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CouponCode;
